import Template from "../../components/Template";
import { useNavigate } from 'react-router-dom';
import { useNavigation } from '../../context/NavigationContext';
import React, { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import config from "../../config";
import * as XLSX from "xlsx";
import AlertDialog from "../../components/AlertDialog";
import { formatCurrencyFromDb } from "../../utils/masks";
import usePermission from "../../hooks/usePermission";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoEmpresa from "../../components/logoEmpresaBase64";
import { useAuth } from '../../context/AuthContext';
import { formatDateWithoutHour } from "../../utils/date";


import useRequisicaoMaisRecente from '../../hooks/useRequisicaoMaisRecente';
const ResumoEmpenho = () => {
    const { auth } = useAuth();
    const navigate = useNavigate();
    const [lista, setLista] = useState([]);
    const { updateMenu } = useNavigation();
    const [obras, setObras] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null); // Estado para o documento selecionado
    const [showDialog, setShowDialog] = useState(false); // Estado para controlar o modal    
    const [selectedPdf, setSelectedPdf] = useState("");
    const [currentPage, setCurrentPage] = useState(1); // Página atual
    const [pageSize, setPageSize] = useState(10); // Define o tamanho inicial
    const [totalRecords, setTotalRecords] = useState(0); // Total de registros    
    const buttonRef = useRef(null);
    const buttonFiltrarRef = useRef(null);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [filters, setFilters] = useState({
        cliente: "",
        obra: "",
        prestador: ""
    });

    const [message, setMessage] = useState("");
    const [columns, setColumns] = useState([]);


    useEffect(() => {
        // Quando 'obras' chega, reconstruímos o array de colunas.
        setColumns([
            {
                id: "contrato",
                label: "Nº Contrato",
                visible: true,
                formatter: (value) => value,
            },
            {
                id: "obra",
                label: "Obra",
                visible: true,
                formatter: (value) => value,
            },
            {
                id: "numeroEmpenho",
                label: "Nº Empenho",
                visible: true,
                formatter: (value) => value,
            },
            {
                id: "valorEmpenho",
                label: "Valor Empenho",
                visible: true,
                formatter: (value) => formatCurrencyFromDb(value) || "",
            },
            {
                id: "dataInicio",
                label: "Período",
                visible: true,
                formatter: (value) =>
                    value ? formatDateWithoutHour(value) : "",
            },
            {
                id: "dataFinal",
                label: "",
                visible: true,
                formatter: (value) =>
                    value ? formatDateWithoutHour(value) : "",
            },
            {
                id: "ordemServico",
                label: "Ordem de Serviço",
                visible: true,
                formatter: (value) => value,
            },
        ]);
    }, [lista]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Só existe uma chamada aqui. A desestruturação pedia tres respostas,
                // entao `clienteRes.data` estourava TypeError, o catch engolia o erro
                // e `setObras` nunca rodava: o filtro de Obra ficava sempre vazio.
                const [obrasRes] = await Promise.all([
                    api.get("/obras/listar/todas"),
                ]);
                setObras(obrasRes.data);
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
            }
        };
        fetchData();
    }, []);

    // Somente na montagem. `handlePageChange` ja refaz a busca levando os filtros;
    // quando este effect tambem dependia de `currentPage`, disparava uma segunda
    // requisicao SEM filtro e o resultado exibido virava uma corrida entre as duas.
    useEffect(() => {
        fetchResumo(currentPage, pageSize);
    }, []);

    // Descarta respostas de filtros que já foram superados por outro mais novo:
    // sem isto, a resposta lenta de um filtro anterior sobrescrevia a tela.
    const requisicaoMaisRecente = useRequisicaoMaisRecente();

    const fetchResumo = async (page, size, filtroObra = "") => {
        try {
            // Monta os query params dinamicamente
            let params = `?page=${page}&pageSize=${size}`;
            if (filtroObra) params += `&obra=${filtroObra}`;
            const idRequisicao = requisicaoMaisRecente.iniciar();
            const response = await api.get(`/relatorios/resumo-empenhos${params}`);
            // Chegou atrasada e ja foi superada por outro filtro: descarta.
            if (!requisicaoMaisRecente.ehAtual(idRequisicao)) return;

            console.log('Response', response.data.records);
            setLista(response.data.records || []);
            setTotalRecords(response.data.total || 0);
            setPageSize(size);
        } catch (error) {
            console.error("Erro ao carregar dados:", error);
        }
    };

    const handleCloseDialog = () => {
        setSelectedDoc(null);
        setShowDialog(false);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchResumo(page, pageSize, filters.obra);
    };

    const totalPages = Math.ceil(totalRecords / pageSize);
    const startRecord = (currentPage - 1) * pageSize + 1;
    const endRecord = Math.min(currentPage * pageSize, totalRecords);

    // Janela de páginas exibidas
    const pageWindowSize = 5;
    const startPage = Math.max(1, currentPage - Math.floor(pageWindowSize / 2));
    const endPage = Math.min(totalPages, startPage + pageWindowSize - 1);

    const pageNumbers = Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
    );


    const [menuOpen, setMenuOpen] = useState(false);
    const [menuFiltrarOpen, setMenuFiltrarOpen] = useState(false);

    const toggleColumnVisibility = (id) => {
        setColumns((prevColumns) =>
            prevColumns.map((col) =>
                col.id === id ? { ...col, visible: !col.visible } : col
            )
        );
    };

    // Função para fechar o menu ao clicar fora
    const handleClickOutside = (event) => {
        if (
            buttonRef.current &&
            !buttonRef.current.contains(event.target) &&
            buttonFiltrarRef.current &&
            !buttonFiltrarRef.current.contains(event.target)
        ) {
            setMenuOpen(null);
        }
    };

    useEffect(() => {
        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);

        };
    }, [menuOpen]);

    const handleMenuClick = (event) => {
        // Impede a propagação do evento para o handleClickOutside
        event.stopPropagation();
    };

    const applyFilters = () => {
        setCurrentPage(1);
        fetchResumo(1, pageSize, filters.obra, filters.prestador, filters.cliente);
        setMenuOpen(null); // Fecha o menu de filtro após aplicar
    };

    const clearFilters = () => {
        setFilters({
            status: "",
            obra: ""
        });
        setCurrentPage(1);
        fetchResumo(1, pageSize, "", "", "");
    };

    const exportarResumoObrasPDF = (lista, logoEmpresa) => {
        if (lista.length === 0) return;
        const usuario = auth.user.name || 'Sistema';
        const doc = new jsPDF({ orientation: 'landscape' });
        let y = 20;
        // Título
        doc.setFontSize(16);
        doc.text('PRESTADORES - PAGAMENTOS PENDENTES', 14, y);
        y += 10;
        // Corpo da tabela
        const head = [["Nº CONTRATO", "OBRA", "Nº EMPENHO", "VALOR EMPENHO", "PERÍODO", "", "ORDEM DE SERVIÇO"]];
        const body = lista.map(item => [
            item.contrato,
            item.obra,
            item.numeroEmpenho,
            formatCurrencyFromDb(item.valorEmpenho),
            formatDateWithoutHour(item.dataInicio),
            formatDateWithoutHour(item.dataFinal),
            ""
        ]);
        autoTable(doc, {
            startY: y,
            head,
            body,
            styles: { fontSize: 10, cellPadding: 3 },
            headStyles: { fillColor: [30, 120, 180], textColor: 255, fontStyle: 'bold' },
            alternateRowStyles: { fillColor: [240, 240, 240] }
        });
        // Totalizador abaixo da tabela
        const finalY = doc.lastAutoTable.finalY + 10;
        const totalValor = lista.reduce((sum, item) => sum + (typeof item.valorEmpenho === 'number' ? item.valorEmpenho : parseFloat(String(item.valorEmpenho).replace(/[^\d,.-]/g, '').replace(',', '.')) || 0), 0);
        autoTable(doc, {
            startY: finalY,
            head: [["DESCRIÇÃO", "VALOR"]],
            body: [["VALOR TOTAL", formatCurrencyFromDb(totalValor)]],
            styles: { fontSize: 10, cellPadding: 3 },
            headStyles: { fillColor: [30, 120, 180], textColor: 255, fontStyle: 'bold' },
            columnStyles: { 0: { cellWidth: 120 }, 1: { halign: 'right' } },
            theme: 'striped'
        });
        // Rodapé
        const pages = doc.getNumberOfPages();
        const now = new Date().toLocaleString('pt-BR');
        for (let i = 1; i <= pages; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.text(`Emitido por: ${usuario}`, 14, doc.internal.pageSize.getHeight() - 10);
            doc.text(`Data/Hora: ${now}`, 80, doc.internal.pageSize.getHeight() - 10);
            doc.text(`Página ${i} de ${pages}`, doc.internal.pageSize.getWidth() - 20, doc.internal.pageSize.getHeight() - 10, { align: 'right' });
            if (logoEmpresa) {
                const w = 40, h = 10;
                doc.addImage(logoEmpresa, 'PNG', (doc.internal.pageSize.getWidth() - w) / 2, doc.internal.pageSize.getHeight() - 20, w, h);
            }
        }
        doc.save('resumo_empenho.pdf');
    };

    const exportarResumoObrasExcel = (lista) => {
        if (lista.length === 0) return;
        // Cabeçalho
        const headers = ["Nº CONTRATO", "OBRA", "Nº EMPENHO", "VALOR EMPENHO", "PERÍODO", "", "ORDEM DE SERVIÇO"];
        // Linhas de dados
        const dataRows = lista.map(item => [
            item.cliente,
            item.obra,
            item.prestador,
            typeof item.valorEmpenho === 'number' ? item.valorEmpenho : parseFloat(String(item.valorEmpenho).replace(/[^\d,.-]/g, '').replace(',', '.')) || 0,
            formatDateWithoutHour(item.dataInicio),
            formatDateWithoutHour(item.dataFinal),
            ""
        ]);
        // Totalizador
        const totalValor = dataRows.reduce((sum, row) => sum + (row[3] || 0), 0);
        const blankRow = ["", "", "", "", ""];
        const totalRow = ["TOTAL", "", "", totalValor, ""];
        // Concatena
        const aoa = [headers, ...dataRows, blankRow, totalRow];
        const ws = XLSX.utils.aoa_to_sheet(aoa);
        // Formato moeda
        const totalRows = aoa.length;
        for (let i = 2; i <= totalRows; i++) {
            ws[`D${i}`] && (ws[`D${i}`].z = 'R$ #,##0.00');
        }
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'sheet1');
        XLSX.writeFile(wb, 'resumo_empenho.xlsx');
    }

    return (
        <Template>
            <div className="h-auto w-full p-4 md:p-8 flex flex-col gap-6">
                <div className="flex flex-wrap justify-between items-center gap-4">
                    <div className="text-stone-800 text-xl md:text-2xl font-medium font-['Inter']">Resumo de Empenhos</div>
                </div>
                <div className="flex flex-wrap gap-2 md:gap-4 items-center">
                    <div className="flex-grow min-w-0 flex items-center gap-2">
                        <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-tight">Ver</div>
                        <select
                            className="w-20 h-8 pl-2 pr-2 py-1 bg-white rounded-md border border-slate-300 text-sm text-slate-700"
                            value={pageSize} // O valor do tamanho da página atual
                            onChange={(e) => {
                                const newPageSize = parseInt(e.target.value, 10);
                                setPageSize(newPageSize);
                                setCurrentPage(1);
                                fetchResumo(1, newPageSize, filters.obra);
                            }}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-tight">Resultados</div>
                    </div>
                    <div className="flex flex-wrap gap-2 flex-none w-full md:w-auto">
                        <div ref={buttonRef} className="relative justify-end items-center gap-1 flex cursor-pointer" onClick={() => setMenuOpen(menuOpen === "colunas" ? null : "colunas")}>
                            <div className="justify-start items-center gap-2 flex" >
                                <img className="w-6 h-6 relative " src="/images/icon/columns.png" />
                                <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal">Colunas</div>
                            </div>
                            <img className="w-6 h-4 px-1 justify-center items-center flex" src="/images/icon/chevron-down.png" />
                            {menuOpen === "colunas" && (
                                <div className="absolute top-full left-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-50"
                                    style={{
                                        zIndex: 9999, // Garante que está acima de outros elementos
                                    }}
                                    onClick={handleMenuClick} // Impede que o clique feche o menu
                                >
                                    <div className="p-4 flex flex-col gap-3">
                                        {columns.map((col) => (
                                            <div
                                                key={col.id}
                                                className="flex items-center gap-2"
                                            >
                                                <input
                                                    type="checkbox"
                                                    id={col.id}
                                                    checked={col.visible}
                                                    onChange={() =>
                                                        toggleColumnVisibility(col.id)
                                                    }
                                                />
                                                <label
                                                    htmlFor={col.id}
                                                    className="text-sm text-gray-700"
                                                >
                                                    {col.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div ref={buttonFiltrarRef} className="relative justify-start items-center gap-1 flex cursor-pointer" onClick={() => setMenuOpen(menuOpen === "filtro" ? null : "filtro")} >
                            <div className="justify-start items-center gap-2 flex">
                                <img className="w-8 h-8 px-0.5 py-[3px] justify-center items-center flex" src="/images/icon/filter.png" />
                                <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal">Filtrar</div>
                            </div>
                            <img className="w-6 h-4 px-1 justify-center items-center flex" src="/images/icon/chevron-down.png" />
                            {/* Menu Suspenso */}
                            {menuOpen === "filtro" && (
                                <div
                                    className="absolute top-full left-0 mt-2 w-[350px] bg-white rounded-md shadow-lg z-50 p-4 border border-gray-300"
                                    style={{ zIndex: 9999 }}
                                    onClick={handleMenuClick} // Impede que o clique feche o menu
                                >
                                    <div className="flex flex-col gap-4">
                                        <div className="self-stretch justify-start items-center gap-2.5 inline-flex">
                                            <div className="grow shrink basis-0 text-stone-800 text-xl font-medium">
                                                Filtrar
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-1.5">
                                            <div className="text-slate-700 text-sm font-medium leading-tight">
                                                Obra
                                            </div>
                                            <select
                                                name="obra"
                                                className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-base"
                                                value={filters.obra}
                                                onChange={(e) =>
                                                    setFilters({ ...filters, obra: e.target.value })
                                                }
                                            >
                                                <option value="">Selecionar</option>
                                                {obras.map((o) => (
                                                    <option key={o.id} value={o.id}>
                                                        {o.nomeProjeto.toUpperCase()}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="self-stretch flex items-center justify-between gap-4 mt-4">
                                            <button
                                                className="px-4 py-2 w-full bg-white rounded-md border border-stone-500 justify-center items-center gap-2 flex"
                                                onClick={clearFilters}
                                            >
                                                <img className="w-4 h-4 relative" src="/images/icon/eraser.png" />
                                                <div className="text-stone-500 text-sm font-medium font-['Inter'] leading-normal" >Limpar</div>
                                            </button>
                                            <button
                                                className="px-4 py-2 w-full bg-stone-600 rounded-md justify-center items-center gap-2 flex"
                                                onClick={applyFilters}
                                            >
                                                <img className="w-4 h-4 relative" src="/images/icon/filter-white.png" />
                                                <div className="text-white text-sm font-medium font-['Inter'] leading-normal" >Filtrar</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                    <div className="self-stretch flex justify-between gap-4">
                        {usePermission('EXPORTAR_RELATORIOS_RESUMO_EMPENHO') && (
                            <>
                                <button type='button' className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md flex items-center gap-2" onClick={() => exportarResumoObrasExcel(lista)}>
                                    <img className="w-4 h-4" src="/images/icon/upload.png" />
                                    <div className="text-white text-sm font-medium font-['Inter'] leading-normal">Resumo Excel</div>
                                </button>
                                <button
                                    type='button' className="flex px-4 py-2 bg-slate-600 rounded-md border border-stone-600 justify-center items-center gap-2 cursor-pointer"
                                    onClick={() => exportarResumoObrasPDF(lista, logoEmpresa)}
                                >
                                    <img className="w-4 h-4" src="/images/icon/pdf.png" />
                                    <div className="text-white text-sm font-medium font-['Inter'] leading-normal">Resumo PDF</div>
                                </button>
                            </>
                        )}
                    </div>
                </div>

                <div className="overflow-x-auto md:overflow-x-visible">
                    <table className="min-w-full bg-white border-collapse border border-gray-200">
                        <thead className="bg-stone-200">
                            <tr>
                                {columns
                                    .filter((col) => col.visible)
                                    .map((col) => (
                                        <th className="px-4 py-2 border border-slate-200 text-slate-800 text-base font-bold">{col.label}</th>
                                    ))}
                            </tr>
                        </thead>
                        <tbody>
                            {lista.map((doc) => (
                                <tr key={doc.id}>
                                    {columns
                                        .filter((col) => col.visible)
                                        .map((col) => (
                                            <td key={`${doc.id}-${col.id}`} className="px-4 py-2 border border-slate-200 text-slate-700 text-base">{col.formatter(doc[col.id], doc)}</td>
                                        ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="self-stretch justify-end items-center gap-2.5 inline-flex">
                    <div className="grow shrink basis-0 text-slate-500 text-base font-normal font-['Inter'] leading-[29.60px]">
                        Mostrando de {startRecord} até {endRecord} de {totalRecords}{" "} registros.
                    </div>
                    <div className="justify-start items-start gap-4 flex">
                        <button
                            className={`w-10 h-10 bg-white/0 rounded border border-[#bebebe] justify-center items-center flex ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-300 cursor-pointer"
                                }`}
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            <img className="w-6 h-6 relative" src="/images/icon/keyboard-arrow-left.png" />
                        </button>

                        {pageNumbers.map((page) => (
                            <button
                                key={page}
                                className={`w-10 h-10 rounded  justify-center items-center flex text-base font-semibold font-['Inter'] ${page === currentPage
                                    ? "bg-stone-600 text-white"
                                    : "bg-gray-200 text-gray-600"
                                    }`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        ))}
                        <button className={`w-10 h-10 bg-white/0 rounded border border-[#bebebe] justify-center items-center flex 
                        ${currentPage === totalPages ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
                            disabled={currentPage === totalPages}
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            <img className="w-6 h-6 relative" src="/images/icon/keyboard-arrow-right.png" />
                        </button>
                    </div>
                </div>
                {showDialog && (
                    <div className="fixed top-0 left-0 w-full h-full bg-black/90 z-50 p-10 flex-col justify-start items-end gap-10 inline-flex overflow-hidden">
                        <div className=" rounded-lg w-full max-w-[80%] h-full max-h-[90%] flex flex-col">
                            <div className="flex justify-between items-center p-4">
                                <div className="flex items-center gap-4">
                                    <a href={config.urlArquivo(selectedPdf)} download target="_blank">
                                        <img className="w-6 h-6 relative  overflow-hidden" src="images/icon/download.png" />
                                    </a>
                                    <div className="w-6 h-6 relative  overflow-hidden" />
                                    <div className="w-6 h-6 relative  overflow-hidden" />
                                </div>
                                <img className="w-6 h-6 relative  overflow-hidden cursor-pointer" src="images/icon/x.png" onClick={handleCloseDialog} />
                            </div>
                            <div className="flex-grow flex justify-center items-center p-4 overflow-hidden">
                                <iframe
                                    src={`${config.urlArquivo(selectedPdf)}#toolbar=0`}
                                    className="w-full h-full border-0"
                                    style={{ border: 'none' }}
                                    title="PDF Viewer"
                                />
                            </div>
                        </div>
                    </div>
                )}

                <AlertDialog
                    isVisible={showSuccessDialog}
                    message={message}
                    onClose={() => setShowSuccessDialog(false)}
                />
            </div>
        </Template>
    )
}
export default ResumoEmpenho;